import { render, staticRenderFns } from "./SystemLog.vue?vue&type=template&id=3caf3476&scoped=true&"
import script from "./SystemLog.vue?vue&type=script&lang=js&"
export * from "./SystemLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3caf3476",
  null
  
)

export default component.exports